import { css } from '@emotion/react';
import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../../../styled';
import { Theme } from '../../../../theme/interface/detailed';

type Interface = { className: string; children: ReactNode };

const styles = css`
	align-items: flex-start;
	display: flex;
	flex-direction: column;

	& > * {
		text-align: left;
	}
`;

const Component = ({ className, children }: Interface): ReactElement => <div className={className}>{children}</div>;

export const AgentTextWrapper = styled(Component)(
	({
		theme: {
			chat: {
				header: { agentTextWrapper },
			},
		},
	}: {
		theme: Theme;
	}) => agentTextWrapper,
	styles
);
